import React, { useState, useMemo } from "react";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";

// Conteúdo da central de ajuda. Para incluir uma pergunta, adicione um item neste array.
const FAQ = [
  {
    id: 0,
    categoria: "Primeiros passos",
    titulo: "O que é sistema de Votação Eletrônica?",
    busca: "acesse a página de cadastro preencha o formulário com as informações solicitadas, lembre-se que sua senha precisa ter pelo menos um número e uma letra, clique em cadastrar e pronto, você receberá uma mensagem no email informado para ativar sua conta e poder utilizar todos os recursos da plataforma. é um sistema fornecido por nós para que você, síndico, possa gerenciar e cadastrar suas assembleias virtuais de forma consistentemente organizada, permitindo que todos os condôminos participem das reuniões do conforto de suas casas ou onde quer que estejam.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Acesse a página de <Link to="/cadastro">cadastro</Link>{" "}
        preencha o formulário com as informações solicitadas,
        lembre-se que sua senha precisa ter pelo menos um número e uma
        letra, clique em cadastrar e pronto, você receberá uma
        mensagem no email informado para ativar sua conta e poder
        utilizar todos os recursos da plataforma.
      </p>
      <p className="ui-ajuda-texto">
        É um sistema fornecido por nós para que você, síndico, possa
        gerenciar e cadastrar suas Assembleias Virtuais de forma
        consistentemente organizada, permitindo que todos os
        condôminos participem das reuniões do conforto de suas casas
        ou onde quer que estejam.
      </p>
      <p className="ui-ajuda-texto">Veja como criar suas Assembleias Virtuais:</p>
      <div className="ui-ajuda-div-iframe">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/gtxn5tPfgIE"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="Aprenda a criar suas Assembleias Virtuais com o Vote Assembleia"
          allowFullScreen
        />
      </div>
      </>
    ),
  },
  {
    id: 1,
    categoria: "Assembleias",
    titulo: "O que diz a Lei nº 14.010 DE 10 DE JUNHO DE 2020?",
    busca: "conforme o art. 5, a assembleia geral, inclusive para os fins do art. 59 do código civil, até 30 de outubro de 2020, poderá ser realizada por meios eletrônicos, independentemente de previsão nos atos constitutivos da pessoa jurídica. parágrafo único. a manifestação dos participantes poderá ocorrer por qualquer meio eletrônico indicado pelo administrador, que assegure a identificação do participante e a segurança do voto, e produzirá todos os efeitos legais de uma assinatura presencial. art. 12, a assembleia condominial, inclusive para os fins dos arts. 1.349 e 1.350 do código civil, e a respectiva votação poderão ocorrer, em caráter emergencial, até 30 de outubro de 2020, por meios virtuais, caso em que a manifestação de vontade de cada condômino será equiparada, para todos os efeitos jurídicos, à sua assinatura presencial. parágrafo único. não sendo possível a realização de assembleia condominial na forma prevista no caput, os mandatos de síndico vencidos a partir de 20 de março de 2020 ficam prorrogados até 30 de outubro de 2020. para ver a lei na integra, acesse aqui",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Conforme o Art. 5, a assembleia geral, inclusive para os fins
        do art. 59 do Código Civil, até 30 de outubro de 2020, poderá
        ser realizada por meios eletrônicos, independentemente de
        previsão nos atos constitutivos da pessoa jurídica.
      </p>
      <p className="ui-ajuda-texto">
        Parágrafo único. A manifestação dos participantes poderá
        ocorrer por qualquer meio eletrônico indicado pelo
        administrador, que assegure a identificação do participante e
        a segurança do voto, e produzirá todos os efeitos legais de
        uma assinatura presencial.
      </p>
      <p className="ui-ajuda-texto">
        Art. 12, a assembleia condominial, inclusive para os fins dos
        arts. 1.349 e 1.350 do Código Civil, e a respectiva votação
        poderão ocorrer, em caráter emergencial, até 30 de outubro de
        2020, por meios virtuais, caso em que a manifestação de
        vontade de cada condômino será equiparada, para todos os
        efeitos jurídicos, à sua assinatura presencial.
      </p>
      <p className="ui-ajuda-texto">
        Parágrafo único. Não sendo possível a realização de assembleia
        condominial na forma prevista no caput, os mandatos de síndico
        vencidos a partir de 20 de março de 2020 ficam prorrogados até
        30 de outubro de 2020.
      </p>
      <p className="ui-ajuda-texto">
        <a href="http://www.planalto.gov.br/ccivil_03/_ato2019-2022/2020/lei/L14010.htm">
          Para ver a Lei na integra, acesse Aqui
        </a>
      </p>
      </>
    ),
  },
  {
    id: 2,
    categoria: "Primeiros passos",
    titulo: "Como ficam os moradores/associados que não usam nada de tecnologia?",
    busca: "nosso app é muito simples de ser utilizado! todo o cadastro é feito pelo síndico ou administradora. o condômino deve apenas clicar na opção de seu interesse pelo celular. hoje a maioria das pessoas estão precisando e usando algum tipo de aplicativo de celular. na nossa página disponibilizamos vídeos com passo a passo para cada funcionalidade.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Nosso app é muito simples de ser utilizado! Todo o cadastro é
        feito pelo síndico ou administradora. O condômino deve apenas
        clicar na opção de seu interesse, pelo aplicativo (Google Play
        ou App Store) ou pelo site, no celular ou no computador. Hoje a maioria
        das pessoas estão precisando e usando algum tipo de aplicativo
        de celular. Na nossa página disponibilizamos vídeos com passo
        a passo para cada funcionalidade.
      </p>
      </>
    ),
  },
  {
    id: 3,
    categoria: "Primeiros passos",
    titulo: "O Vote condomínio funciona em qualquer lugar do Brasil?",
    busca: "sim, em todo o território nacional",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Sim, em todo o território nacional
      </p>
      </>
    ),
  },
  {
    id: 4,
    categoria: "Primeiros passos",
    titulo: "Como os síndicos e administradoras usam a plataforma?",
    busca: "temos um vídeo no nosso canal que explica as principais funções do app e como utilizá-las:",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Temos um vídeo no nosso canal que explica as principais
        funções do App e como utilizá-las:
      </p>
      <div className="ui-ajuda-div-iframe">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/k5aBxYfIPbg"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="Como os síndicos e administradoras usam a plataforma?"
          allowFullScreen
        />
      </div>
      </>
    ),
  },
  {
    id: 31,
    categoria: "Para condôminos",
    titulo: "Os condôminos podem votar pelo site, sem instalar o aplicativo?",
    busca: "sim votar pelo site sem instalar aplicativo navegador celular computador app.voteassembleia.com.br/votar token de acesso google play app store lojas",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Sim! Agora o condômino pode votar de <b>duas formas</b>: pelo aplicativo <b>Vote Assembleia</b> (Google Play ou
        App Store) <b>ou direto pelo site</b>, no celular ou no computador, sem instalar nada.
      </p>
      <ol className="ui-ajuda-texto">
        <li>Acesse <a href="https://app.voteassembleia.com.br/votar" target="_blank" rel="noopener noreferrer">app.voteassembleia.com.br/votar</a>.</li>
        <li>Digite o <b>token de acesso</b> da unidade (o mesmo código recebido por e-mail).</li>
        <li>Escolha a votação aberta, vote em cada pauta e confirme. Ao terminar, os resultados aparecem na aba <b>Resultados</b>, com gráficos.</li>
      </ol>
      <p className="ui-ajuda-texto">
        A tela mostra sempre o nome do condomínio e da unidade que está votando. Por segurança, só uma aba do navegador
        vota por vez e a sessão termina sozinha após 30 minutos sem uso. Ao tocar em <b>Sair</b>, os dados são removidos
        do navegador. Cada pauta aceita um voto por unidade: repetir o voto não conta duas vezes.
      </p>
      </>
    ),
  },
  {
    id: 32,
    categoria: "Para condôminos",
    titulo: "O condômino já usa o aplicativo e quer votar pelo site. Precisa de um novo código?",
    busca: "novo código token de acesso gerar novo token votar pelo site um aparelho por vez já existe outro aparelho conectado a sua conta editar unidade",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        O token de acesso funciona em <b>um aparelho ou navegador por vez</b>. Se o condômino já entrou com o código no
        aplicativo e agora quer votar pelo site (ou o contrário), aparece a mensagem "Já existe outro aparelho conectado
        a sua conta".
      </p>
      <p className="ui-ajuda-texto">Para liberar o acesso, o síndico ou a administradora deve <b>gerar um novo código</b> para o condômino:</p>
      <ol className="ui-ajuda-texto">
        <li>Abra o condomínio e vá em <b>Unidades</b>.</li>
        <li>Edite a unidade do condômino e clique em <b>Gerar Novo Token</b> (a importação de planilha também tem a opção de gerar novo token).</li>
        <li>Envie o novo código ao condômino: ele serve para o aplicativo <b>e</b> para o site.</li>
      </ol>
      <p className="ui-ajuda-texto">
        Atenção: o código antigo deixa de valer, e o novo vale para todas as unidades do mesmo responsável. O e-mail
        enviado ao condômino já informa que ele pode votar pelo Google Play, pela App Store ou pelo site.
      </p>
      <p className="ui-ajuda-texto">
        Se o condômino só quer sair do aparelho atual, basta tocar em <b>Sair</b> (no aplicativo ou no site): a unidade
        fica livre para entrar em outro lugar com o mesmo código.
      </p>
      </>
    ),
  },
  {
    id: 5,
    categoria: "Para condôminos",
    titulo: "Vocês tem algum vídeo que explique para os condôminos como usar o app?",
    busca: "sim! temos um canal no youtube que possui vídeos explicativos tanto da visão do condômino quanto do síndico ou administradora",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">Sim! Temos um canal no YouTube</p>
      <div className="ui-ajuda-div-iframe">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/9Apr7GLRS1Q"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="Vocês tem algum vídeo que explique para os condôminos como
          usar o app?"
          allowFullScreen
        />
      </div>
      <p className="ui-ajuda-texto">
        que possui vídeos explicativos tanto da visão do condômino
        quanto do síndico ou administradora
      </p>
      </>
    ),
  },
  {
    id: 6,
    categoria: "Para condôminos",
    titulo: "Como os condôminos podem atualizar o App?",
    busca: "temos vídeos no nosso do youtube que explica tanto na versão ios quanto na android",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Basta abrir a loja de aplicativos do celular, procurar por <b>Vote Assembleia</b> e tocar em <b>Atualizar</b>.
      </p>
      <ol className="ui-ajuda-texto">
        <li><b>iPhone (iOS):</b> abra a <b>App Store</b>, toque na sua foto no canto superior direito e, em "Atualizações disponíveis", toque em <b>Atualizar</b> ao lado do Vote Assembleia.</li>
        <li><b>Android:</b> abra a <b>Google Play</b>, toque na sua foto no canto superior direito, vá em <b>Gerenciar apps e dispositivo</b> e toque em <b>Atualizar</b> ao lado do Vote Assembleia.</li>
      </ol>
      <p className="ui-ajuda-texto">
        Se o botão mostrar "Abrir" em vez de "Atualizar", o seu aplicativo já está na versão mais recente.
      </p>
      </>
    ),
  },
  {
    id: 7,
    categoria: "Assembleias",
    titulo: "Como seria a transmissão online?",
    busca: "o síndico/administradora pode criar uma reunião numa plataforma tipo zoom e cadastrar na assembleia. por dentro do app o condômino pode acessar esse link e abrir a webconferência. a partir daí, as perguntas / pautas da votação ficam abertas para discussão também via chat e voto.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        O síndico/administradora pode criar uma reunião numa
        plataforma tipo Zoom e cadastrar na assembleia. Por dentro do
        app o condômino pode acessar esse link e abrir a
        webconferência. A partir daí, as perguntas / pautas da votação ficam
        abertas para discussão também via chat e voto.
      </p>
      </>
    ),
  },
  {
    id: 8,
    categoria: "Assembleias",
    titulo: "Ao término da Assembleia, é possível salvar ou gravar a reunião no Google Meets ou no Zoom?",
    busca: "qualquer documento pode ser anexado e colocado em arquivos de uma determinada reunião.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Qualquer documento pode ser anexado e colocado em arquivos de
        uma determinada reunião.
      </p>
      </>
    ),
  },
  {
    id: 9,
    categoria: "Assembleias",
    titulo: "Como coloco o link do Google Meets ou do Zoom para enviar pelo Vote Assembleia?",
    busca: "para o link da reunião, existe um campo quando cadastrar a votação para que informe esse link. muito simples também. o link ficará disponível para os condôminos no app.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Para o link da reunião, existe um campo quando cadastrar a
        votação para que informe esse link. Muito simples também. O
        link ficará disponível para os condôminos no app.
      </p>
      <p className="ui-ajuda-texto">Veja no vídeo como cadastrar e gerenciar a votação:</p>
      <div className="ui-ajuda-div-iframe">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/L3i_5qFPWVY"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="Gerenciar Votação"
          allowFullScreen
        />
      </div>
      </>
    ),
  },
  {
    id: 10,
    categoria: "Para condôminos",
    titulo: "É possível utilizar o computador para acessar o App ou apenas o celular?",
    busca: "o síndico/administradora utiliza o computador e o condômino apenas pelo celular.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        O síndico/administradora utiliza o computador e o condômino
        apenas pelo celular.
      </p>
      </>
    ),
  },
  {
    id: 11,
    categoria: "Assembleias",
    titulo: "E sobre unidade votante com procuração? Como é o processo?",
    busca: "na prática, não precisamos mais de procuração, uma vez que todos podem votar. de qualquer forma, o síndico pode cadastrar o procurador na plataforma ao invés do proprietário, arquivando a procuração.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Na prática, não precisamos mais de procuração, uma vez que
        todos podem votar. De qualquer forma, o síndico pode cadastrar
        o procurador na plataforma ao invés do proprietário,
        arquivando a procuração.
      </p>
      </>
    ),
  },
  {
    id: 12,
    categoria: "Assembleias",
    titulo: "Com esse sistema e observando a nova Lei, preciso enviar a convocação por e-mail?",
    busca: "você pode fazer a convocação pelo próprio app. assim que cadastrar a reunião existe a possibilidade do envio da convocação, onde todos os condôminos receberão por email, dando amplo conhecimento a todos.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Você pode fazer a convocação pelo próprio app. Assim que
        cadastrar a reunião existe a possibilidade do envio da
        convocação, onde todos os condôminos receberão por email,
        dando amplo conhecimento a todos.
      </p>
      <p className="ui-ajuda-texto">Veja como funciona a convocação digital:</p>
      <div className="ui-ajuda-div-iframe">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/RKdZKOEyW2o"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="Convocação Digital"
          allowFullScreen
        />
      </div>
      </>
    ),
  },
  {
    id: 13,
    categoria: "Para condôminos",
    titulo: "Como é feita a lista de presença?",
    busca: "a lista de presença é feita em formato pdf, para ter acesso a ela o síndico ou administradora deverá clicar em relatórios dentro de gerenciar votações.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        A lista de presença é feita em formato pdf, para ter acesso a
        ela o síndico ou administradora deverá clicar em relatórios
        dentro de gerenciar votações.
      </p>
      </>
    ),
  },
  {
    id: 14,
    categoria: "Para condôminos",
    titulo: "No aplicativo existe possibilidades do morador/associado abrir reuniões? Exemplo discutir alguma atitude do síndico com outros moradores/associados.",
    busca: "depois que o síndico ou administradora abrir a reunião, abaixo de cada pergunta da votação tem um chat, onde os condôminos podem discutir suas opiniões e dar sugestões, que por sua vez fica registrado na plataforma.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Depois que o síndico ou administradora abrir a reunião, abaixo
        de cada pergunta da votação tem um chat, onde os condôminos
        podem discutir suas opiniões e dar sugestões, que por sua vez
        fica registrado na plataforma.
      </p>
      </>
    ),
  },
  {
    id: 15,
    categoria: "Para condôminos",
    titulo: "Como condômino, como faço para acessar o app?",
    busca: "logo após você instalar o app, você receberá um código de ativação de seu síndico ou administradora por e-mail ou sms para acessar o app e começar a participar das assembleias de forma virtual.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Logo após você instalar o app, você receberá um código de
        ativação de seu síndico ou administradora por e-mail ou sms
        para acessar o app e começar a participar das assembleias de
        forma virtual.
      </p>
      </>
    ),
  },
  {
    id: 16,
    categoria: "Assembleias",
    titulo: "O que faço no caso de inadimplência, por exemplo?",
    busca: "nesse caso você poderá bloquear a unidade votante e se desejar poderá ativá-la futuramente.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Nesse caso você poderá bloquear a unidade votante e se desejar poderá
        ativá-la futuramente.
      </p>
      </>
    ),
  },
  {
    id: 17,
    categoria: "Primeiros passos",
    titulo: "O cadastramento dos proprietários e unidades votantes. Como funciona? Passamos uma lista para vcs com os dados?",
    busca: "para a entrada dos dados das unidades votantes, temos duas possibilidades. a primeira é a digitação, mais demorado. a segunda, mais prática, existe uma funcionalidade onde você mesmo consegue importar seus dados a partir de uma planilha eletrônica. muito prático e rápido!",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Para a entrada dos dados das unidades votantes, temos duas
        possibilidades. A primeira é a digitação, mais demorado. A
        segunda, mais prática, existe uma funcionalidade onde você
        mesmo consegue importar seus dados a partir de uma planilha
        eletrônica. Muito prático e rápido!
      </p>
      </>
    ),
  },
  {
    id: 18,
    categoria: "Assembleias",
    titulo: "Quanto a validade da votação, ata da assembleia e registro em cartório da mesma?",
    busca: "o sistema já gera a ata com todos os resultados, permitindo que outros textos possam ser inseridos. a ata pode ser registrada em cartório normalmente. fizemos uma parceria com um cartório virtual que a ata pode ser enviada eletronicamente por dentro do aplicativo e você recebe de volta eletronicamente a ata registrada. nesse caso, esse é um serviço opcional e o registro deve ser pago diretamente ao cartório. não temos nenhuma participação comercial nisso, apenas facilitando a vida dos clientes. mas é opcional, pode continuar registrando no seu cartório normalmente.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        O sistema já gera a ata com todos os resultados, permitindo
        que outros textos possam ser inseridos. A ata pode ser
        registrada em cartório normalmente. Fizemos uma parceria com
        um cartório virtual que a ata pode ser enviada eletronicamente
        por dentro do aplicativo e você recebe de volta
        eletronicamente a ata registrada. Nesse caso, esse é um
        serviço opcional e o registro deve ser pago diretamente ao
        cartório. Não temos nenhuma participação comercial nisso,
        apenas facilitando a vida dos clientes. Mas é opcional, pode
        continuar registrando no seu cartório normalmente.
      </p>
      </>
    ),
  },
  {
    id: 19,
    categoria: "Para condôminos",
    titulo: "Como autentica o usuário para confirmar que é um condômino realmente?",
    busca: "isso é feito via token de acesso que o usuário recebe via email no endereço eletrônico cadastrado na plataforma.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Isso é feito via Token de acesso que o usuário recebe via
        Email no endereço eletrônico cadastrado na plataforma. O mesmo
        token serve para votar pelo aplicativo ou pelo site.
      </p>
      </>
    ),
  },
  {
    id: 20,
    categoria: "Primeiros passos",
    titulo: "Como usar um importar um arquivo CSV para cadastrar as unidades votantes?",
    busca: "temos um vídeo no nosso canal do youtube que explica como importar arquivos nesse formato:",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Temos um vídeo no nosso canal do YouTube que explica como
        importar arquivos nesse formato:
      </p>
      <div className="ui-ajuda-div-iframe">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/yzf4ckyYkXI"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="Como usar um importar um arquivo CSV para cadastrar as unidades votantes?"
          allowFullScreen
        />
      </div>
      </>
    ),
  },
  {
    id: 21,
    categoria: "Assembleias",
    titulo: "Como anexar arquivos grandes?",
    busca: "no caso de arquivos grandes sugerimos usar o google drive, temos um vídeo no nosso canal do youtube:",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        No caso de arquivos grandes sugerimos usar o Google Drive. Veja como fazer:
      </p>
      <ol className="ui-ajuda-texto">
        <li>Envie o arquivo para o seu <b>Google Drive</b>.</li>
        <li>Clique com o botão direito no arquivo, escolha <b>Compartilhar</b> e, em "Acesso geral", selecione <b>Qualquer pessoa com o link</b> (permissão de leitor).</li>
        <li>Clique em <b>Copiar link</b>.</li>
        <li>No Vote Assembleia, ao criar ou editar a votação, cole o link no campo de anexos/descrição. Os condôminos acessam o documento pelo link dentro do aplicativo.</li>
      </ol>
      </>
    ),
  },
  {
    id: 22,
    categoria: "Para condôminos",
    titulo: "Como os condôminos podem saber mais sobre os candidatos a síndico?",
    busca: "a plataforma foi construída para fazer qualquer tipo de votação. você pode abrir uma votação com os nomes dos candidatos. o cadastro é feito pelo síndico no site.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        A plataforma foi construída para fazer qualquer tipo de
        votação. Você pode abrir uma votação com os nomes dos
        candidatos. O cadastro é feito pelo síndico no site.
      </p>
      </>
    ),
  },
  {
    id: 23,
    categoria: "Planos e pagamento",
    titulo: "Como faço minha assinatura?",
    busca: "faça já seu cadastro aqui em seguida, basta adquirir as unidades votantes que deseja para seu condomínio / sociedade / associação. você pode assistir nosso vídeo no youtube que explica detalhadamente como fazer a assinatura:",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        <Link to="/cadastro">Faça já seu cadastro Aqui</Link>
      </p>
      <p className="ui-ajuda-texto">
        Em seguida, basta adquirir as unidades votantes que deseja para seu
        Condomínio / Sociedade / Associação. Você pode assistir nosso vídeo no YouTube que
        explica detalhadamente como fazer a assinatura:
      </p>
      <div className="ui-ajuda-div-iframe">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/VCzuIyrLM00"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          title="Pagamento Vote Assembleia"
          allowFullScreen
        />
      </div>
      </>
    ),
  },
  {
    id: 24,
    categoria: "Planos e pagamento",
    titulo: "Depois de ter assinado o pacote anual posso adicionar mais unidades vontantes?",
    busca: "sim! você poderá adicionar mais unidades votantes do seu condomínio / sociedade / associação futuramente.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Sim! Você poderá adicionar mais unidades votantes do seu Condomínio / Sociedade / Associação
        futuramente.
      </p>
      </>
    ),
  },
  {
    id: 26,
    categoria: "Planos e pagamento",
    titulo: "Como funciona o pagamento?",
    busca: "você escolhe um plano e paga o valor do plano mais um valor por unidade votante. 1 mês r$ 99,90 + r$ 1,90 por unidade. 6 meses r$ 199,90 + r$ 1,90 por unidade. 1 ano r$ 329,90 + r$ 3,90 por unidade. assembleias e votações ilimitadas. exemplo 50 unidades votantes.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Assembleias e votações <span className="ui-texto-destaque">ilimitadas</span> em todos os planos.
        Você paga o valor do plano <span className="ui-texto-destaque">mais um valor por unidade votante</span>:
      </p>
      <ul className="ui-ajuda-texto">
        <li><b>1 mês:</b> <span className="ui-texto-destaque">R$ 99,90</span> + R$ 1,90 por unidade votante</li>
        <li><b>6 meses:</b> <span className="ui-texto-destaque">R$ 199,90</span> + R$ 1,90 por unidade votante (equivale a R$ 33,32 por mês)</li>
        <li><b>1 ano:</b> <span className="ui-texto-destaque">R$ 329,90</span> + R$ 3,90 por unidade votante (equivale a R$ 27,49 por mês)</li>
      </ul>
      <p className="ui-ajuda-texto">
        Veja um exemplo: para um Condomínio / Sociedade / Associação com{" "}
        <span className="ui-texto-destaque">50 unidades votantes</span>, o total é de{" "}
        <span className="ui-texto-destaque">R$ 194,90</span> no plano de 1 mês,{" "}
        <span className="ui-texto-destaque">R$ 294,90</span> no de 6 meses e{" "}
        <span className="ui-texto-destaque">R$ 524,90</span> no plano de 1 ano.
      </p>
      <p className="ui-ajuda-texto">
        Os valores e o total do seu pedido aparecem na tela de compra, em "Comprar unidades votantes",
        antes de você finalizar o pagamento.
      </p>
      </>
    ),
  },
  {
    id: 27,
    categoria: "Planos e pagamento",
    titulo: "Como é feito o pagamento para utilizar o app?",
    busca: "o pagamento pode ser feito por pix ou boleto bancário, processado pelo nitrus. pix a compra é liberada em poucos minutos. boleto aguarde a compensação de 1 a 3 dias úteis.",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        O pagamento pode ser feito por <span className="ui-texto-destaque">PIX</span> ou{" "}
        <span className="ui-texto-destaque">boleto bancário</span>, em ambiente seguro processado pelo Nitrus.
        Com o PIX, a compra é liberada em poucos minutos e você já pode realizar sua assembleia virtual!
        No caso do boleto, precisamos aguardar a compensação bancária, de 1 a 3 dias úteis.
      </p>
      <p className="ui-ajuda-texto">
        Você recebe um e-mail de confirmação e a tela de compra avança sozinha assim que o pagamento é confirmado.
      </p>
      </>
    ),
  },
  {
    id: 28,
    categoria: "Condomínios",
    titulo: "Como desativar ou reativar um condomínio?",
    busca: "desativar reativar condomínio sociedade associação inativo ativo editar interruptor condomínio ativo some do painel dashboard sem excluir dados mantidos",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Quando um Condomínio / Sociedade / Associação não precisa mais aparecer no seu painel, você pode{" "}
        <span className="ui-texto-destaque">desativá-lo</span> sem excluir nada:
      </p>
      <ol className="ui-ajuda-texto">
        <li>Abra o condomínio e clique em <b>Editar</b> (ou use o botão de editar na visão geral).</li>
        <li>Na seção <b>Configurações</b>, desligue a opção <b>Condomínio ativo</b>.</li>
        <li>Clique em <b>Salvar alterações</b>.</li>
      </ol>
      <p className="ui-ajuda-texto">
        Ele deixa de aparecer na lista principal e no seletor de condomínios do menu lateral. Unidades, proprietários,
        votações e histórico continuam guardados. Para <span className="ui-texto-destaque">reativar</span>, abra a
        lista com o filtro <b>Inativos</b>, entre no condomínio, edite e ligue <b>Condomínio ativo</b> de novo.
      </p>
      </>
    ),
  },
  {
    id: 29,
    categoria: "Condomínios",
    titulo: "Como ver apenas os condomínios ativos, inativos ou todos?",
    busca: "filtro ativos inativos todos lista de condomínios sociedades associações painel dashboard selo inativo",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Na tela <b>Condomínios / Sociedades / Associações</b> há três abas logo acima da lista:
      </p>
      <ul className="ui-ajuda-texto">
        <li><b>Ativos:</b> abre por padrão e mostra só os que estão em uso.</li>
        <li><b>Inativos:</b> mostra os desativados, com o selo <span className="ui-texto-destaque">Inativo</span> no cartão.</li>
        <li><b>Todos:</b> mostra os dois juntos.</li>
      </ul>
      <p className="ui-ajuda-texto">
        Desativar um condomínio não é o mesmo que o plano vencer: o selo "Vencido" ou "Não ativado" indica a situação
        do pagamento, enquanto "Inativo" indica que você o tirou do painel.
      </p>
      </>
    ),
  },
  {
    id: 30,
    categoria: "Primeiros passos",
    titulo: "Como funciona a verificação em dois fatores (2FA) no login?",
    busca: "2fa dois fatores código por e-mail aplicativo autenticador código de recuperação lembrar neste navegador encerrar navegadores lembrados segurança login perfil",
    conteudo: (
      <>
      <p className="ui-ajuda-texto">
        Por segurança, o login do painel exige um <span className="ui-texto-destaque">segundo passo</span>. Depois de
        informar e-mail e senha, você digita um código de verificação, que pode ser enviado por{" "}
        <b>e-mail</b> (vale por 10 minutos) ou gerado por um <b>aplicativo autenticador</b>.
      </p>
      <p className="ui-ajuda-texto">
        Para trocar o método, vá em <b>Perfil → Segurança e acesso</b> e escolha "Código por e-mail" ou "Aplicativo
        autenticador". Se perder o acesso ao aplicativo, use um dos códigos de recuperação.
      </p>
      <p className="ui-ajuda-texto">
        Em um computador de confiança, marque <b>Lembrar neste navegador</b> na tela do código: ele não pedirá o código
        por 7 dias. Para cancelar, use <b>Encerrar navegadores lembrados</b> em Perfil → Segurança e acesso. Depois de
        muitas tentativas erradas o acesso é bloqueado por 10 minutos.
      </p>
      </>
    ),
  },
];

const CATEGORIAS = ["Todas", ...Object.keys(FAQ.reduce((acc, it) => ({ ...acc, [it.categoria]: 1 }), {}))];

const ICONES = {
  "Todas": "th large",
  "Primeiros passos": "rocket",
  "Para condôminos": "mobile alternate",
  "Assembleias": "calendar check outline",
  "Planos e pagamento": "credit card outline",
  "Condomínios": "building outline",
};

const normalizar = texto =>
  String(texto).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export default function Ajuda(props) {
  const [aberto, setAberto] = useState(null);
  const [categoria, setCategoria] = useState("Todas");
  const [busca, setBusca] = useState("");

  const itens = useMemo(() => {
    const termo = normalizar(busca.trim());
    return FAQ.filter(it =>
      (categoria === "Todas" || it.categoria === categoria) &&
      (!termo || normalizar(it.titulo).includes(termo) || normalizar(it.busca).includes(termo))
    );
  }, [busca, categoria]);

  return (
    <div id="home">
      <MenuHorizontal {...props} />
      <div className="va-ajuda">
        <section className="va-ajuda-hero">
          <span className="va-contato-etiqueta"><Icon name="book" /> Central de ajuda</span>
          <h1>Como podemos ajudar?</h1>
          <p>Encontre respostas sobre cadastro, assembleias, pagamento e uso do aplicativo.</p>
          <div className="va-ajuda-busca">
            <Icon name="search" />
            <input
              type="search"
              placeholder="Busque por uma dúvida, ex.: ata, procuração, pagamento..."
              value={busca}
              onChange={e => { setBusca(e.target.value); setAberto(null); }}
              aria-label="Buscar na central de ajuda"
            />
          </div>
        </section>

        <div className="va-ajuda-corpo">
          <nav className="va-ajuda-categorias" aria-label="Categorias">
            {CATEGORIAS.map(cat => (
              <button
                type="button"
                key={cat}
                className={categoria === cat ? "ativo" : ""}
                onClick={() => { setCategoria(cat); setAberto(null); }}
              >
                <Icon name={ICONES[cat] || "folder outline"} /> {cat}
                <span>{cat === "Todas" ? FAQ.length : FAQ.filter(it => it.categoria === cat).length}</span>
              </button>
            ))}
          </nav>

          <div className="va-ajuda-lista">
            {itens.length === 0 && (
              <div className="va-ajuda-vazio">
                <Icon name="search" size="big" />
                <p>Nenhum resultado para <b>"{busca}"</b>.</p>
                <Link to="/fale-conosco">Fale com a nossa equipe</Link>
              </div>
            )}
            {itens.map(it => {
              const ativo = aberto === it.id;
              return (
                <article key={it.id} className={`va-ajuda-item ${ativo ? "aberto" : ""}`}>
                  <button
                    type="button"
                    className="va-ajuda-pergunta"
                    aria-expanded={ativo}
                    onClick={() => setAberto(ativo ? null : it.id)}
                  >
                    <span>
                      <small>{it.categoria}</small>
                      {it.titulo}
                    </span>
                    <Icon name={ativo ? "minus" : "plus"} />
                  </button>
                  {ativo && <div className="va-ajuda-resposta ui-ajuda-texto-wrap">{it.conteudo}</div>}
                </article>
              );
            })}

            <div className="va-ajuda-contato">
              <div>
                <b>Não encontrou o que procurava?</b>
                <span>Nossa equipe responde em até 1 dia útil.</span>
              </div>
              <Link to="/fale-conosco" className="ui button btn-ui-1">
                <Icon name="mail outline" /> Fale conosco
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
